import H from 'constants/httpMethod.const';
import UMSG_TYPE from 'constants/umsg/type.const';
import fromDtoToStylistsCommissions from 'dto/stylist/fromDtoToStylistsCommissions.dto';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import fromAnyToNumber from 'utils/converters/fromAnyToNumber.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';
import isPositiveNumber from 'utils/predicates/number/isPositiveNumber.util';

const fromAnyToIdMaybe = (any) => {
  const int = fromAnyToInteger(any);
  return isPositiveNumber(int) ? int : void 1;
};

const fromAnyToPercentage = (any) => {
  const num = fromAnyToNumber(any);

  return Number.isFinite(num) ? (num / 100).toFixed(4) : void 1;
};

const fromCommissionToCreateDto = (item) => ({
  percentage: fromAnyToPercentage(item?.percentage),
  stylist: fromAnyToIdMaybe(item?.stylistId),
  object_id: fromAnyToIdMaybe(item?.categoryId) ?? fromAnyToIdMaybe(item?.objectId) ?? null,
  object_type: item?.objectType,
});

const fromCommissionToUpdateDto = (item) => ({
  percentage: fromAnyToPercentage(item?.percentage),
});

export const ibeStylistsCommissionsRead = actionEndpointBe('ibeStylistsCommissionsRead', H.get, 'salon/v2/:salonId/stylists/commissions/', {
  inert: true,
  fromDto: fromDtoToStylistsCommissions,
  umsg: UMSG_TYPE.global,
});

export const ibeStylistsCommissionsCreate = actionEndpointBe('ibeStylistsCommissionsCreate', H.post, 'salon/v2/:salonId/stylist/:stylistId/commissions/', (options, extra) => ({
  ...options,
  inert: true,
  fromDto: alwaysSame,
  toDto: fromCommissionToCreateDto,
  umsg: UMSG_TYPE.global,
  params: { stylistId: extra?.stylistId },
  data: extra?.data,
}));

export const ibeStylistsCommissionsUpdate = actionEndpointBe('ibeStylistsCommissionsUpdate', H.put, 'salon/v2/:salonId/stylist/:stylistId/commissions/:commissionId/', (options, extra) => ({
  inert: true,
  fromDto: alwaysSame,
  toDto: fromCommissionToUpdateDto,
  umsg: UMSG_TYPE.global,
  params: { stylistId: extra?.stylistId, commissionId: extra?.commissionId },
  data: extra?.data,
}));
